import { apiGet, apiPost, apiPatch } from './client';
import type { RevisionsListResponse } from '../types/api';

export async function getRevisions(
  websiteId: string
): Promise<RevisionsListResponse> {
  return apiGet<RevisionsListResponse>(`/api/revisions/${websiteId}`);
}

export async function processRevision(
  revisionId: string
): Promise<{ success: boolean; message: string }> {
  return apiPost<{ success: boolean; message: string }>(
    `/api/revision/${revisionId}/process`
  );
}

export type ManualRevisionStatus = 'pending' | 'processing' | 'completed' | 'rejected';

/**
 * Set a revision's status by hand, without running the AI processor.
 *
 * `note` is shown to the CUSTOMER in the portal — as the reason beside
 * "Not being made" for a rejection, or as an update otherwise. It is
 * required when rejecting.
 */
export async function setRevisionStatus(
  revisionId: string,
  status: ManualRevisionStatus,
  note?: string
): Promise<{ success: boolean; status: string; previousStatus: string }> {
  return apiPatch<{ success: boolean; status: string; previousStatus: string }>(
    `/api/revision/${revisionId}/status`,
    { status, note }
  );
}
